module.exports = __webpack_public_path__ + "static/uic.cf705bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/uic.png
// module id = 2204
// module chunks = 61762850755587